import { protectedResources } from '../../authConfig';
import makeGetRequestAsync, { makePostRequestAsync } from '../Helpers/httpRequestHelpers';
import { NotificationMessage } from './Models/NotificationMessage';
import { NotificationModel } from './Models/NotificationModel';

const apiScopes = protectedResources.notificationsWebApi.scopes;
const baseUrl = protectedResources.notificationsWebApi.endpoint;

/*
 *  Retrieves a specific notification based on a passed notification ID
 */
export async function GetNotificationById(notificationId: number) {
  const url = `${baseUrl}/api/Notifications/Notification/${notificationId}`;
  return (await makeGetRequestAsync<NotificationModel>(apiScopes, url)).data;
}

/*
 *  Retrieves all notifications based on a passed recipient account ID
 */
export async function GetNotificationsByRecipientAccountId(
  recipientAccountId: string,
  isRead: boolean
) {
  const url = `${baseUrl}/api/Notifications/Notification/GetNotificationsByRecipientAccountId/${recipientAccountId}/${isRead}`;
  return (await makeGetRequestAsync<Array<NotificationModel>>(apiScopes, url)).data;
}

export const AddNewNotification = async (notification: NotificationMessage) => {
  const url = `${baseUrl}/api/Notifications/Notification/AddNotification`;
  await makePostRequestAsync(apiScopes, url, notification);
};
